import * as components from './components';

const ACC = window.ACC || {
  vars: {},
  methods: {},
};

document.addEventListener('DOMContentLoaded', () => {
  const componentNodes = Array.from(document.querySelectorAll('[data-component]')) || [];

  componentNodes.forEach(node => {
    const componentName = node.getAttribute('data-component');

    let props = node.getAttribute('data-props');
    if (props) props = JSON.parse(props);

    /* eslint-disable no-new */
    new components[componentName](node, props);
  });
});

ACC.methods.setViewportHeightInCss = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

window.addEventListener('resize', ACC.methods.setViewportHeightInCss);

ACC.methods.setViewportHeightInCss();
